const config = {
  // API_BASE_URL: "https://dentrey.com/api/",
  API_BASE_URL: "https://testing.dentrey.com/api/",
};

export default config;
